import { useEffect, useState } from "react";
import { installStaffRequestHeader } from "../../utilities/staffRequestHeader";
import AgencyFormTemplateManager from "../Agency/AgencyFormTemplateManager";

// Staff view of an agency's form templates: the same upload, edit and Auto-detect
// flow the agency admin has, run on the agency's behalf. Every request goes
// through the staff endpoints and carries the verified admin email.
const AgencyFormsTab: React.FC<{ agencyId: string; agencyName: string; adminEmail: string }> = ({
  agencyId,
  agencyName,
  adminEmail,
}) => {
  // The header must be in place before the list's first request. Children run
  // their mount effects before this component does, so hold them back until it
  // is installed.
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const remove = installStaffRequestHeader(adminEmail);
    setReady(true);
    return () => {
      remove();
      setReady(false);
    };
  }, [adminEmail]);

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 dark:bg-blue-900/40 border border-blue-200 dark:border-blue-800 rounded-md p-3 text-sm text-blue-800 dark:text-blue-300">
        Manage form templates for <strong>{agencyName}</strong>. Forms you upload here are shared with every officer in the
        agency. Open one to place fields by hand or use Auto-detect fields, exactly as the agency's admin can.
      </div>
      {ready && (
        <AgencyFormTemplateManager
          key={agencyId}
          embedded
          apiBase={`/api/agency-management/agencies/${agencyId}/form-templates`}
        />
      )}
    </div>
  );
};

export default AgencyFormsTab;
